import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'platform'
})
export class AccessRightService {
  public isLoading: boolean = true;
}
